import { FC, useState } from "react";

import Button from "../UI/Button/Button";

import { chromiaBackendUrl } from "../../settings";
import { useStoreDispatch, useStoreSelector } from "../../store/store";
// import { connect } from "../../utils/Chromia/connect";

import './ChromiaRegisterPage.scss';


const ChromiaRegisterPage: FC = () => {

	const {userAddress} = useStoreSelector(store => store.app);
	const [isRegistering, setIsRegistering] = useState(false);
	const [isRegistrationFailed, setIsRegistrationFailed] = useState(false);
	const {setIsChrRegistered} = useStoreDispatch();

	const registerAcc = async () => {
		if (!userAddress) throw new Error('no client addr');

		setIsRegistering(true);

		const response = await fetch(`${chromiaBackendUrl}/ft4/register_account_and_mint_assets?evm_address=${userAddress}`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({evm_address: userAddress})
		});

		if (response.ok) {
			setIsRegistering(false);
			setIsChrRegistered(true);
		} else {
			setIsRegistrationFailed(true);
		}
		/* .then(res => {
			if (res.ok) {
			return 'OK'
			}
			return res.text().then(text => text)
		}) */
	}


	return (
		<div
			className="ChromiaRegisterPage"
		>
			<div>
				No account in <span className="ChromiaRegisterPage-textGradient">Chromia</span>
			</div>
			<br/>
			{isRegistrationFailed?
				<div>
					Registration failed
				</div>
			:
				isRegistering?
					<div>
						Register in progress...
					</div>
				:
					<Button
						action={registerAcc}
					>
						Register
					</Button>
			}
		</div>
	)
}

export default ChromiaRegisterPage;